import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { isIncompleteResubmission } from '@app/@shared/order-resubmission';
import { LandingPageService } from '@app/pages/landing-page/landing-page.service';
import { LoginService } from '@app/pages/login/login.service';
import { SessionStorageService } from '@app/sessionStorage.service';

// Orders sent back as "incomplete" resume at business info, exactly as after a password login.
export const incompleteOrderRedirectGuard: CanActivateFn = (): Observable<boolean | UrlTree> | boolean => {
  const token = sessionStorage.getItem('token');
  if (!token) {
    return true;
  }

  const router = inject(Router);
  const sessionStorageService = inject(SessionStorageService);
  const decodedToken = Object(inject(LoginService).decodeToken(token));

  // Fetched fresh because the order may have been marked incomplete after login.
  return inject(LandingPageService)
    .getOrder(decodedToken.privilegeId)
    .pipe(
      map((res: any): boolean | UrlTree => {
        if (!isIncompleteResubmission(res?.json)) {
          return true;
        }
        sessionStorageService.saveData(res.json);
        sessionStorageService.saveData({}, SessionStorageService.EXISTING_ORDER_FLOW);
        return router.createUrlTree([res.json.subscriptionType === 'POS+' ? '/business-information' : '/business-information2']);
      }),
      catchError(() => of(true)),
    );
};
